import React from "react";
import SafeImage from "../../layout/reusable/SafeImage";

/* =========================
   RECRUITMENT STATUS LOGIC
========================= */
export const getRecruitmentStatus = (startDate, closeDate) => {
    const now = new Date();
    const start = startDate ? new Date(startDate) : null;
    const end = closeDate ? new Date(closeDate) : null;

    const formatDate = (date) =>
        date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "long",
            year: "numeric",
        });

    // ❌ sudah lewat
    if (end && now > end) {
        return {
            status: "closed",
            label: "CLOSED",
        };
    }

    // ⏳ belum mulai
    if (start && now < start) {
        return {
            status: "upcoming",
            label: `Registration opens on ${formatDate(start)}`,
        };
    }

    // ✅ sedang berjalan
    if (end) {
        return {
            status: "open",
            label: `Hiring until ${formatDate(end)}`,
        };
    }

    return {
        status: "open",
        label: "Hiring Open",
    };
};

/* =========================
   COMPONENT
========================= */
const RecruitmentSingleMain = ({ singleData }) => {
    if (!singleData) return null;

    const {
        titleEn,
        titleId,
        positionEn,
        positionId,
        typeEn,
        typeId,
        image,
        startDate,
        closeDate,
        descriptionEn,
        descriptionId,
    } = singleData;

    // ✅ FIX: statusInfo sekarang ADA
    const statusInfo = getRecruitmentStatus(startDate, closeDate);

    return (
        <section className="recruitment-detail section-padding">
            <div className="container">
                <div className="col-lg-9 mx-auto">

                    <div className="divider" />
                    {/* HEADER */}
                    <div className="recruitment-detail__header text-center">
                        <span className="badge-en">
                            {titleEn} {titleId && `- ${titleId}`}
                        </span>

                        <h2>{positionEn}</h2>
                        <p className="position-id">{positionId}</p>
                        {/* STATUS */}
                        <div
                            className={`recruitment-detail__status w-100 text-center status-${statusInfo.status}`}
                        >
                            {statusInfo.label}
                        </div>
                        <div className="divider" />

                        <div className="meta">
                            <span>{typeEn}</span>
                            <span>{typeId}</span>
                            <span>
                                Valid from{" "}
                                {new Date(startDate).toLocaleDateString("en-GB")}{" "}
                                –{" "}
                                {new Date(closeDate).toLocaleDateString("en-GB")}
                            </span>
                        </div>
                    </div>

                    {/* IMAGE */}
                    {image && (
                        <SafeImage
                            src={image}
                            alt={positionEn}
                            className="hero-image"
                        />
                    )}

                    <div className="divider" />

                    {/* DESCRIPTION */}
                    <div className="recruitment-detail__content">
                        {descriptionEn && (
                            <div
                                className="desc-en"
                                dangerouslySetInnerHTML={{
                                    __html: descriptionEn,
                                }}
                            />
                        )}

                        {descriptionId && (
                            <div
                                className="desc-id"
                                dangerouslySetInnerHTML={{
                                    __html: descriptionId,
                                }}
                            />
                        )}
                    </div>


                </div>
            </div>
        </section>
    );
};

export default RecruitmentSingleMain;
